const config = {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  qrUrl: process.env.REACT_APP_QR_URL
}
export default config;
